import { ResourceOptions } from 'react-admin';
import { FaAccessibleIcon } from 'react-icons/fa';
import { Resources } from '../resource';

export { default as list } from './List';

export const name = Resources.systemRpc;
export const icon = FaAccessibleIcon;
export const options: ResourceOptions = {
  label: 'resource.systemRpc',
};
